import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { LoyaltyEducation, LoyaltyEducationContentType, LoyaltyPointsEducation } from 'models/common/loyalty-education';

import { UitkButtonSize, UitkPrimaryButton } from 'uitk-react-button';
import { UitkImage } from 'uitk-react-images';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { UitkSpacing } from 'uitk-react-spacing';

import { DoubleLink } from 'components/common/media/double-link';
import { LoyaltyEducationContent } from './loyalty-education-content';

const LinkTracked = ClickTracker(DoubleLink);

interface LoyaltyEducationDialogContentProps {
  loyaltyEducation?: LoyaltyEducation;
}

export const LoyaltyEducationDialogContent: React.FunctionComponent<LoyaltyEducationDialogContentProps> = ({ loyaltyEducation }) => {
  if (!loyaltyEducation) {
    return null;
  }

  const { title, content, action } = loyaltyEducation;
  let heroImage = null;

  if (content && content._type === LoyaltyEducationContentType.POINTS) {
    const contentPoints = content as LoyaltyPointsEducation;

    if (contentPoints.heroImage) {
      heroImage = contentPoints.heroImage;
    }
  }

  return (
    <React.Fragment>
      {heroImage && (
        <UitkSpacing padding={{ blockend: 'six' }}>
          <section>
            <UitkImage alt={heroImage.description} src={heroImage.url} />
          </section>
        </UitkSpacing>
      )}

      {title && <h1 className="uitk-type-heading-600 uitk-type-bold all-y-margin-four">{title}</h1>}
      {content && (
        <section>
          <LoyaltyEducationContent type={content._type} content={content} />
        </section>
      )}

      {action && action.text && (
        <UitkScrim type={UitkScrimType.BUTTON}>
          <LinkTracked to={action.href} rfrr={action.rfrr} linkName="Rewards Dialog Button">
            <UitkPrimaryButton id="join-rewards-btn" data-stid="join-rewards-btn" isFullWidth={true} size={UitkButtonSize.LARGE}>
              {action.text}
            </UitkPrimaryButton>
          </LinkTracked>
        </UitkScrim>
      )}
    </React.Fragment>
  );
};
